"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromFieldError_1 = require("./FromFieldError");
var FormFieldState = /** @class */ (function () {
    function FormFieldState(value, validator, dependentFields, hasError, errorMessage) {
        if (dependentFields === void 0) { dependentFields = {}; }
        if (hasError === void 0) { hasError = false; }
        if (errorMessage === void 0) { errorMessage = null; }
        this.defaultValidator = function () { return FromFieldError_1.FORM_FIELD_NO_ERROR; };
        this.value = value;
        this.validator = validator || this.defaultValidator;
        this.dependentFields = dependentFields;
        this.hasErrors = hasError;
        this.errorMessage = errorMessage;
    }
    FormFieldState.prototype.validate = function () {
        return this.validator(this);
    };
    FormFieldState.prototype.setValue = function (newValue) {
        var currentValue = this.value;
        this.value = newValue;
        if (currentValue !== newValue) {
            this.updateErros(this.validate());
        }
    };
    FormFieldState.prototype.refresh = function () {
        return this.updateErros(this.validate());
    };
    FormFieldState.prototype.updateErros = function (error) {
        if (error) {
            this.hasErrors = error.hasErrors;
            this.errorMessage = error.message;
        }
    };
    return FormFieldState;
}());
exports.default = FormFieldState;
